
import styled from "styled-components"
import {GoCheck} from "react-icons/go"
import { FaCheck } from "react-icons/fa";
const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;

    .grp-item{

        display: flex;
        align-items: center;
        gap: 10px;

        .box{
            width: 22px;
            height: 22px;
            border-radius: 3px;
            border: solid ${({theme}) => theme.mainTextColor};
            border-width: ${({borderSize}) => borderSize};

            display: flex;
            justify-content: center;
            align-items: center;

            .check-icon{
                font-size: .9rem;
                color:#000;
            }
        }

        .label{
            font-size: ${({fontSize}) => fontSize};
            font-weight: ${({fontWeight}) => fontWeight};
            color: ${({theme}) => theme.mainTextColor};
        }
    }

`

const InputRadio = ({data, setData, name, isRequired, labelText1, labelText2, fontSize="12px", fontWeight="var(--font-weight-xl)", borderSize="2px"}) => {

  return (
    <Container fontSize={fontSize} fontWeight={fontWeight} borderSize={borderSize} >
        <div className="grp-item" onClick={() => setData(true)}>
            <div className="box">{data && <FaCheck className="check-icon"/>}</div>
            <div className="label">{labelText1}</div>
        </div>
        <div className="grp-item" onClick={() => setData(false)}>
            <div className="box">{!data && <FaCheck className="check-icon"/>}</div>
            <div className="label">{labelText2}</div>
        </div>
    </Container>
  )
}

export default InputRadio